import {
  SET_WORDING_TEMPLATES,
  SET_WORDING_TEMPLATE_PARAMS,
  WORDING_TEMPLATE_CHANGED,
} from "../actions/wording";

const initialState = {
  wordingTemplates: {},
  wordingTemplateModalParams: { action: "create", wordingTemplate: {} },
  wordingTemplateChangedEvent: {
    changeType: null,
    templateId: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_WORDING_TEMPLATES:
      return {
        ...state,
        wordingTemplates: action.wordingTemplates,
      };
    case SET_WORDING_TEMPLATE_PARAMS:
      return {
        ...state,
        wordingTemplateModalParams: action.wordingTemplateModalParams,
      };
    case WORDING_TEMPLATE_CHANGED:
      return {
        ...state,
        wordingTemplateChangedEvent: action.payload,
      };
    default:
      return state;
  }
};
